/*-----------------------------------
Navigation Scroll Page
-----------------------------------*/

$(function () {
    "use strict";
    $(".scroll").bind("click", function (event) {
        var $anchor = $(this);
        var headerH = $("#navigation").outerHeight();
        $("html, body")
            .stop()
            .animate(
                {
                    scrollTop: $($anchor.attr("href")).offset().top - headerH + "px",
                },
                1200,
                "easeInOutExpo"
            );

        event.preventDefault();
    });
});

/*-----------------------------------
Show Active Navigation
-----------------------------------*/

var sections = $(".section"),
    links = $(".scroll.link");

$(window).scroll(function () {
    "use strict";
    var currentPosition = $(this).scrollTop();
    links.removeClass("selected");

    sections.each(function () {
        var top = $(this).offset().top - 88,
            bottom = top + $(this).height();

        if (currentPosition >= top && currentPosition <= bottom) {
            $('a[href="#' + this.id + '"]').addClass("selected");
        }
    });
});


/*-----------------------------------
Menu for mobile devices
-----------------------------------*/

$(".mobile-nav-button").click(function () {
    "use strict";
    $(".nav-menu").slideToggle("8000");
});
$(".nav a").click(function () {
    "use strict";
    if ($(window).width() < 960) {
        $(".nav-menu").slideToggle("2000");
    }
});

/** BACK TO TOP **/
$(window).scroll(function() {
    if ($(window).scrollTop() > 400) {
        $("#back-top").fadeIn(200);
    } else {
        $("#back-top").fadeOut(200);
    }
});
$('#back-top').click(function() {
    $('html, body').stop().animate({
        scrollTop : 0
    }, 1500, 'easeInOutExpo');
});
